import { getRandomString } from '@/custom/classes/my_utils'

export default {
  create: (state, payload) => {
    payload.modal_id = getRandomString({ length: 8 })
    state.modals.push(payload)
  },
  update: (state, updated_payload) => {
    state.modals = state.modals.map((modal_payload) => {
      if (modal_payload.modal_id == updated_payload.modal_id) {
        return updated_payload
      }
      return modal_payload
    })
  },
  remove: (state, payload, is_forced_remove) => {
    if (payload.is_fixed && !is_forced_remove) {
      return
    }
    state.modals = state.modals.filter((modal) => payload.modal_id !== modal.modal_id)
  },
  removeModalById: (state, id) => {
    state.modals = state.modals.filter((modal) => id !== modal.modal_id)
  },
  pop: (state, payload) => {
    state.modals.pop()
  },
  clearModals (state) {
    state.modals = state.modals.filter(modal => modal.persistent)
  },
  // A form registers itself as "dirty" so Modal.vue's X-close can ask first
  // instead of silently discarding typed text (UI reviewer issue 2).
  setDirtyGuard (state, { modal_id, value }) {
    if (!modal_id) return
    state.dirtyGuard = { ...state.dirtyGuard, [modal_id]: value === true }
  },
  clearDirtyGuard (state, modal_id) {
    const next = { ...state.dirtyGuard }
    delete next[modal_id]
    state.dirtyGuard = next
  }
}
